import { urlService } from "services";
import { Single } from "types";

const header = document.querySelector("[data-header]");

const closeMenuButton = document.querySelector<HTMLElement>(
  "[data-menu-close]"
);
const headerLogo = document.querySelector<HTMLElement>("[data-header-logo]");
const menuMain = document.querySelector<HTMLElement>("[data-menu-main]");
const lastChildMenuMain = menuMain?.lastElementChild
  ?.querySelector("ul")
  ?.lastElementChild?.querySelector("a");
let previousElement: Element | null | undefined = null;

const openMenuButton = document.querySelector<HTMLElement>("[data-menu-open]");

const openMenu = () => {
  header?.classList.add("is-open");
  document.body.classList.add("disallow-scroll");
};

const closeMenu = () => {
  header?.classList.remove("is-open");
  document.body.classList.remove("disallow-scroll");
};

const hideMenuButtons = () => {
  openMenuButton?.classList.add("is-hidden");
  closeMenuButton?.classList.add("is-hidden");
};

const isMenuOpen: boolean = !!header?.classList.contains("is-open");

(() => {
  const initPath = window.location.pathname;
  const rootSearchUrl = urlService.getSinglePath(Single.search); // search single url
  const pathIsSearchUrl = initPath.includes(rootSearchUrl);

  if (pathIsSearchUrl) {
    closeMenuButton?.addEventListener("click", (event) => {
      event.preventDefault();
      window.location.href = "/";
    });
  } else {
    closeMenuButton?.addEventListener("click", closeMenu);
  }

  document.addEventListener("keydown", (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      closeMenu();
    }

    if (event.key === "Tab") {
      if (previousElement === lastChildMenuMain) {
        headerLogo?.focus();
        window.scrollTo(
          headerLogo?.offsetTop || 0,
          headerLogo?.offsetLeft || 0
        );
      }
    }
    previousElement = document.activeElement;
  });
  openMenuButton?.addEventListener("click", openMenu);
})();

// export to add event listener in search
export {
  openMenu,
  closeMenu,
  isMenuOpen,
  openMenuButton,
  closeMenuButton,
  hideMenuButtons,
};
